import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/core/services/environment.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { Observable } from 'rxjs';
import { QuickLink, QuickLinkSubmit, QuickLinkVerbose, SystemLink } from '../models/quick-links.model';
import { api_routes } from '@app/consts/api-routes';

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class QuickLinksService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getQuickLinks(take?: number, skip?: number, filter?: string, sort?: string, asOf?: string): Observable<PagedData<QuickLink>> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.QUICK_LINKS}`, {
      headers: headers,
      params: params
    });
  }

  async getAllQuickLinks(filter?: string, sort?: string, asOf?: string): Promise<PagedData<QuickLink>> {
    let take = 100;
    let skip = 0;
    let quickLinks = {
      skip: null,
      take: null,
      totalPages: null,
      total: null,
      data: []
    }

    while (quickLinks.total === null || skip < quickLinks.total) {
      const res = await this.getQuickLinks(take, skip, filter, sort, asOf).toPromise();

      if (res && res.data && res.data.length > 0) {
        quickLinks.data = quickLinks.data.concat(res.data);
        skip += take;
        quickLinks.total = res.total;
      } else {
        break;
      }
    }

    return quickLinks;
  }

  getQuickLink(id: string): Observable<QuickLinkVerbose> {
    return this.http.get<QuickLinkVerbose>(`${this.envService.env.apiUrl}${api_routes.QUICK_LINKS}/${id}`, { headers: headers });
  }

  createQuickLink(quickLink: QuickLinkSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.QUICK_LINKS}`, quickLink, { headers: headers });
  }

  updateQuickLink(id: string, quickLink: QuickLinkSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.QUICK_LINKS}/${id}`, quickLink, { headers: headers });
  }

  deleteQuickLink(id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.QUICK_LINKS}/${id}`, { headers: headers });
  }

  getSystemLinks(take?: number, skip?: number, filter?: string, sort?: string, asOf?: string): Observable<PagedData<SystemLink>> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<PagedData<SystemLink>>(`${this.envService.env.apiUrl}${api_routes.SYSTEM_LINKS}`, { headers: headers, params: params });
  }

  async getAllSystemLinks(): Promise<PagedData<SystemLink>> {
    let take = 100;
    let skip = 0;
    let systemLinks = {
      skip: null,
      take: null,
      totalPages: null,
      total: null,
      data: []
    }

    while (systemLinks.total === null || skip < systemLinks.total) {
      const res = await this.getSystemLinks(take, skip).toPromise();

      if (res && res.data && res.data.length > 0) {
        systemLinks.data = systemLinks.data.concat(res.data);
        skip += take;
        systemLinks.total = res.total;
      } else {
        break;
      }
    }

    return systemLinks;
  }
}
